import { jsx as o } from "react/jsx-runtime";
import { FormControl as y } from "../FormControl/FormControl.mjs";
import { forwardRef as N } from "react";
import { SelectBase as R } from "./SelectBase.mjs";
const v = N((a, l) => {
  const {
    name: e,
    children: i,
    controlStyleProps: s,
    controlClassName: d,
    "data-testid": t,
    error: n,
    formHelperText: m,
    hideOptionalLabel: c = !1,
    id: p = e,
    isDisabled: f,
    isReadOnly: r,
    isRequired: S,
    label: b,
    options: h,
    variant: u = "outline",
    ...x
  } = a;
  return /* @__PURE__ */ o(
    y,
    {
      name: e,
      hideOptionalLabel: c,
      id: p,
      "data-testid": t && `${t}-control`,
      error: n,
      label: b,
      isDisabled: f,
      isReadOnly: r,
      isRequired: S,
      formHelperText: m,
      className: d,
      ...s,
      children: /* @__PURE__ */ o(
        R,
        {
          ref: l,
          name: e,
          "data-testid": t,
          variant: r ? "filled" : u,
          options: h,
          ...x,
          children: i
        }
      )
    }
  );
});
v.displayName = "Select";
export {
  v as Select
};
